import React, { useState } from "react";

import Container from "@mui/material/Container";
import ApplicationPanel from "../application/ApplicationPanel";
import ApplicationHeader from "../application/ApplicationHeader";
import { notBlank } from "../util/ext";
import { useOrganizationSearch } from "./organizationServices";
import OrganizationsBrowse from "./OrganizationsBrowse";
import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useResolvedPath,
} from "react-router-dom";
import RequireRoles from "../auth/RequireRoles";
import OrganizationView from "./OrganizationView";

const ADMIN = ["ROLE_ADMIN"];

const initialSearchState = {
  appliedFilter: null,
  activeOnly: true,
  orderBy: "organizationName",
  orderDirection: "asc",
  page: 0,
};

const ManageOrganizationsView = () => {
  const url = useResolvedPath(".").pathname;
  const navigate = useNavigate();

  const [searchState, setSearchState] = useState(initialSearchState);
  const searchResults = useOrganizationSearch({
    filter: searchState.appliedFilter,
    order: notBlank(searchState.orderBy)
      ? `${searchState.orderBy}:${searchState.orderDirection}`
      : null,
    page: searchState.page,
    activeOnly: searchState.activeOnly,
  });

  return (
    <Container id="manage-subscriptions" disableGutters>
      <ApplicationHeader />

      <Routes>
        <Route
          path="organizations"
          element={
            <RequireRoles roles={ADMIN}>
              <ApplicationPanel id="application-panel-organizations">
                <OrganizationsBrowse
                  searchState={searchState}
                  onSearchStateChange={state => setSearchState(state)}
                  searchResults={searchResults}
                />
              </ApplicationPanel>
            </RequireRoles>
          }
        />

        <Route
          path="organizations/:organizationId"
          element={
            <RequireRoles roles={ADMIN}>
              <ApplicationPanel id="application-panel-organization">
                <OrganizationView
                  onCancel={() => navigate(`${url}/organizations`)}
                />
              </ApplicationPanel>
            </RequireRoles>
          }
        />

        <Route index element={<Navigate to="organizations" replace />} />
      </Routes>
    </Container>
  );
};

export default ManageOrganizationsView;
